import { Config, ConfigProvider, Layer } from "effect";

/**
 * App store mode configuration
 * - "waitlist": Show "Join the Waitlist" CTA with email form
 * - "live": Show iOS/Android app store download buttons
 */
export const appStoreModeConfig = Config.literal("waitlist", "live")("APP_STORE_MODE").pipe(
  Config.withDefault("waitlist" as const),
);

/**
 * iOS App Store URL (optional, only used when mode is "live")
 */
export const iosAppStoreUrlConfig = Config.option(Config.string("IOS_APP_STORE_URL"));

/**
 * Android Play Store URL (optional, only used when mode is "live")
 */
export const androidPlayStoreUrlConfig = Config.option(Config.string("ANDROID_PLAY_STORE_URL"));

/**
 * Combined app store configuration
 */
export const appStoreConfigAll = Config.all({
  mode: appStoreModeConfig,
  iosUrl: iosAppStoreUrlConfig,
  androidUrl: androidPlayStoreUrlConfig,
});

/**
 * App store configuration type
 */
export type AppStoreConfig = Config.Config.Success<typeof appStoreConfigAll>;

/**
 * Load app store configuration from environment
 */
export const loadAppStoreConfig = appStoreConfigAll;

/**
 * Default configuration provider using environment variables with VITE_ prefix
 */
export const AppStoreConfigLive = Layer.setConfigProvider(
  ConfigProvider.fromMap(
    new Map([
      /* v8 ignore next -- @preserve Vite environment variable fallback */
      ["APP_STORE_MODE", import.meta.env.VITE_APP_STORE_MODE ?? "waitlist"],
      ["IOS_APP_STORE_URL", import.meta.env.VITE_IOS_APP_STORE_URL ?? ""],
      ["ANDROID_PLAY_STORE_URL", import.meta.env.VITE_ANDROID_PLAY_STORE_URL ?? ""],
    ]),
  ),
);
